(function () {
  function productInfoFor(el) {
    return (el.closest && el.closest('[id^="MainProduct-"]')) || document.querySelector('[id^="MainProduct-"]');
  }
  function setSelected(picker, card) {
    picker.querySelectorAll('[data-rb-variant-card]').forEach(function (c) {
      var sel = c === card;
      c.classList.toggle('is-selected', sel);
      c.setAttribute('aria-checked', sel ? 'true' : 'false');
    });
  }
  function updatePrice(card, info) {
    var wrap = info.querySelector('[data-rb-main-price]');
    var sell = info.querySelector('[data-rb-main-selling-price]');
    var badge = info.querySelector('[data-rb-main-discount]');
    var cmp = info.querySelector('[data-rb-main-compare-price]');
    if (sell && card.dataset.price) sell.textContent = card.dataset.price;
    var dv = Number(card.dataset.discount || 0);
    if (badge) { badge.textContent = dv > 0 ? dv + '% OFF' : ''; badge.classList.toggle('hidden', dv <= 0); }
    var cv = card.dataset.comparePrice || '';
    if (cv) {
      if (!cmp && wrap) {
        cmp = document.createElement('s');
        cmp.className = 'price-item price-item--regular rb-main-price__mrp';
        cmp.setAttribute('data-rb-main-compare-price', '');
        if (badge) { wrap.insertBefore(cmp, badge); } else { wrap.appendChild(cmp); }
      }
      if (cmp) { cmp.textContent = cv; cmp.hidden = false; }
    } else if (cmp) { cmp.hidden = true; cmp.textContent = ''; }
  }
  function updateForm(card, info) {
    var id = card.dataset.variantId; if (!id) return;
    info.querySelectorAll('form[action*="/cart/add"] input[name="id"], form.installment input[name="id"], input.product-variant-id')
      .forEach(function (inp) { inp.value = id; });
  }
  function updateAtc(card, info) {
    var btn = info.querySelector('.product-form__submit, button[name="add"]'); if (!btn) return;
    var un = card.disabled || card.getAttribute('aria-disabled') === 'true';
    var c = btn.querySelector('.custom-atc-content') || btn.querySelector('.custom-atc-text');
    if (un) { btn.setAttribute('disabled', ''); if (c) c.textContent = 'Sold out'; }
    else { btn.removeAttribute('disabled'); if (c) c.textContent = 'Add to cart'; }
  }
  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('[data-rb-variant-picker] [data-rb-variant-card]');
    if (!card || card.disabled) return;
    // Run before (and instead of) the theme's slow variant handler.
    e.preventDefault();
    e.stopImmediatePropagation();
    var picker = card.closest('[data-rb-variant-picker]');
    var info = productInfoFor(card);
    if (picker) setSelected(picker, card);
    if (info) { updatePrice(card, info); updateForm(card, info); updateAtc(card, info); }
  }, true);
})();